import React, { Component } from "react";

import Input from "./Input";
import Label from "./Label";
import InputRow from "./InputRow";

export { Input as Input };
export { Label as Label };
export { InputRow as InputRow };

class Form extends Component {
  onSubmit(e) {
    e.preventDefault();
    this.props.onSubmit();
  }

  render() {
    let { action, method } = this.props;

    return (
      <form
        className="form"
        action={action}
        method={method}
        onSubmit={this.onSubmit.bind(this)}
      >
        {this.props.children}
      </form>
    );
  }
}

Form.defaultProps = {
  action: "",
  method: "post",
  onSubmit: function () {},
};

export default Form;
